// Deduplicate sidebar repair requests across mounted consumers and limit retries.
const repairs = new Map();
export function ensureTeamQuotaAccounting({teamId,uid,version,repair}) {
  if (!teamId || !uid || Number(version) >= 2) return Promise.resolve(null);
  const key=JSON.stringify([teamId,uid]),cached=repairs.get(key);
  if(cached && cached.until>Date.now())return cached.promise;
  const promise=Promise.resolve().then(()=>repair({teamId}));
  repairs.set(key,{promise,until:Date.now()+60000});
  return promise;
}
